/** TVA proposées (codes Pennylane) et statuts des devis / factures, pour l'affichage. */
export const VAT_OPTIONS = [
  { value: 'FR_200', label: '20 %', rate: 20 },
  { value: 'FR_100', label: '10 %', rate: 10 },
  { value: 'FR_85', label: '8,5 %', rate: 8.5 },
  { value: 'FR_55', label: '5,5 %', rate: 5.5 },
  { value: 'FR_21', label: '2,1 %', rate: 2.1 },
  { value: 'exempt', label: 'Exonéré', rate: 0 },
]

export const vatRate = (code) => VAT_OPTIONS.find((v) => v.value === code)?.rate ?? 0

export const QUOTE_STATUS = {
  draft: { label: 'Brouillon', tone: 'text-ink/60 border-ink/15 bg-ink/5' },
  pending: { label: 'Envoyé (Pennylane)', tone: 'text-sky-300 border-sky-400/30 bg-sky-400/10' },
  accepted: { label: 'Accepté', tone: 'text-brand-text border-brand/30 bg-brand/10' },
  denied: { label: 'Refusé', tone: 'text-red-300 border-red-400/30 bg-red-400/10' },
  invoiced: { label: 'Facturé', tone: 'text-violet-300 border-violet-400/30 bg-violet-400/10' },
  expired: { label: 'Expiré', tone: 'text-amber-300 border-amber-400/30 bg-amber-400/10' },
}

export const INVOICE_STATUS = {
  draft: 'Brouillon',
  upcoming: 'À venir',
  late: 'En retard',
  paid: 'Payée',
  partially_paid: 'Payée en partie',
  cancelled: 'Annulée',
  credit_note: 'Avoir',
  incomplete: 'Incomplète',
}

export const formatEuros = (value) =>
  Number(value || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })

export const inputClass =
  'w-full rounded-xl border border-ink/10 bg-ink/5 px-3 py-2 text-sm text-ink placeholder-ink/30 outline-none focus:border-brand/50'

/** Formules de contrat = modèles (comme l'ancien workflow n8n), et montants HT à saisir. */
export const CONTRACT_FORMULAS = [
  { value: 'F3', label: 'Forfait', description: '40 % à la commande, 40 % le mois suivant, 20 % à la livraison', amounts: ['package'] },
  { value: 'F3R', label: 'Forfait + récurrent', description: 'Forfait 40/40/20 et maintenance / hébergement mensuels', amounts: ['package', 'monthlyRecurring'] },
  { value: 'F24', label: 'Forfait en 24 mois', description: 'Forfait réglé en 24 mensualités', amounts: ['package'] },
  { value: 'F24R', label: 'Forfait 24 mois + récurrent', description: '24 mensualités et maintenance / hébergement mensuels', amounts: ['package', 'monthlyRecurring'] },
  { value: 'A', label: 'Abonnement', description: 'Abonnement tout compris, engagement 24 mois', amounts: ['monthlySubscription'] },
]

export const AMOUNT_LABELS = {
  package: 'Forfait de développement (€ HT)',
  monthlyRecurring: 'Récurrent mensuel (€ HT / mois)',
  monthlySubscription: 'Abonnement (€ HT / mois)',
}

export const CONTRACT_STATUS = {
  draft: { label: 'Brouillon', tone: 'text-ink/60 border-ink/15 bg-ink/5' },
  generated: { label: 'Généré', tone: 'text-brand-text border-brand/30 bg-brand/10' },
}
